import styled from 'styled-components';

export const ContainerItems = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1rem;
`;
